import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { SortableHandle, SortableItem, SortableList } from '@/components/ui/SortableList';

import { State } from '../State';

const START = [
  { id: 'featured', name: 'Featured Content' },
  { id: 'campaigns', name: 'Campaigns' },
  { id: 'guides', name: 'Guides' },
  { id: 'surveys', name: 'Surveys' },
];

export function SortableListExamples() {
  const [ids, setIds] = useState(START.map((entry) => entry.id));
  const names = new Map(START.map((entry) => [entry.id, entry.name]));

  return (
    <>
      <State
        title="Drag, keyboard or buttons"
        note="Drag the handle; or focus it, press Space, use the arrow keys and press Space again; or use Move up and Move down. Every move is announced."
      >
        <SortableList ids={ids} nameOf={(id) => names.get(id) ?? id} onReorder={setIds}>
          <Box sx={{ display: 'grid', gap: 1 }} data-testid="gallery-sortable-list">
            {ids.map((id) => (
              <SortableItem key={id} id={id} testId={`gallery-sortable-list-${id}`}>
                {({ ref, style }) => (
                  <Paper
                    ref={ref}
                    style={style}
                    variant="outlined"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.5 }}
                  >
                    <SortableHandle />
                    <Typography>{names.get(id)}</Typography>
                  </Paper>
                )}
              </SortableItem>
            ))}
          </Box>
        </SortableList>
      </State>

      <State
        title="Read-only"
        note="Nothing moves; the controls stay to show where they would be."
      >
        <SortableList
          ids={ids.slice(0, 2)}
          nameOf={(id) => names.get(id) ?? id}
          onReorder={() => {}}
          disabled
        >
          <Box sx={{ display: 'grid', gap: 1 }}>
            {ids.slice(0, 2).map((id) => (
              <SortableItem
                key={id}
                id={id}
                testId={`gallery-sortable-list-disabled-${id}`}
              >
                {({ ref, style }) => (
                  <Paper
                    ref={ref}
                    style={style}
                    variant="outlined"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.5 }}
                  >
                    <SortableHandle />
                    <Typography>{names.get(id)}</Typography>
                  </Paper>
                )}
              </SortableItem>
            ))}
          </Box>
        </SortableList>
      </State>
    </>
  );
}
